import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M10.5507 0H56V32H10.5507L0 16L10.5507 0Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 32

/**
 * Tag Left shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const TagLeftShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default TagLeftShape
